
 $('.hm-banner-slider').owlCarousel({
      items: 1,
      loop: true,
      margin: 0,
      nav: false,
      dots: true,
      autoplay: true,
      autoplayTimeout: 10000,
      autoplayHoverPause: true,
      smartSpeed: 1200
    });

    
$(document).ready(function(){
    $('.testimonial-carousel').owlCarousel({
        loop: true,
        margin: 30,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3500,
        autoplayHoverPause: true,

        smartSpeed: 1200,
        autoplaySpeed: 1200,
        slideTransition: 'linear',
      responsive:{
        0:{
          items:1,
          nav: true,
        },
        1036:{
          items:2
        },
        1000:{
          items:2
        }
      }
    });
  });

  document.querySelector('.back-to-top')?.addEventListener('click', function(e) {
  e.preventDefault();
  window.scrollTo({ top: 0, behavior: 'smooth' });
});


$(document).ready(function(){

  var owl = $('.skincare-slider');

  owl.owlCarousel({
    loop:true,
    margin:30,
    nav:false,
    dots:false,
    smartSpeed:600,
    stagePadding:0,

    responsive:{
      0:{
        items:1.2
      },
      768:{
        items:2.2
      },
      1200:{
        items:3.6
      }
    },

    onInitialized:function(event){
      setActiveItem(event);
      updatePagination(event);
    },

    onTranslated:function(event){
      setActiveItem(event);
      updatePagination(event);
    }
  });

  $('.next-btn').click(function(){
    owl.trigger('next.owl.carousel');
  });

  $('.prev-btn').click(function(){
    owl.trigger('prev.owl.carousel');
  });

  // Active Large First Item
  function setActiveItem(event){

    $('.skincare-slider .owl-item').removeClass('active-large');

    var firstActive = $('.skincare-slider .owl-item.active').first();

    firstActive.addClass('active-large');
  }

  // Pagination
  function updatePagination(event){

    var carousel = event.relatedTarget;

    var current = carousel.relative(carousel.current()) + 1;

    var total = carousel.items().length;

    $('.current-slide').text(
      current.toString().padStart(2, '0')
    );

    $('.total-slide').text(
      total.toString().padStart(2, '0')
    );

    var progress = (current / total) * 100;

    $('.active-line').css('width', progress + '%');
  }







});


document.addEventListener('DOMContentLoaded', function () {
  const parentMenu = document.getElementById('HeaderDrawer-shop-by-category');
  const childMenu = parentMenu.nextElementSibling;

  parentMenu.addEventListener('click', function (e) {
    e.preventDefault();
    childMenu.classList.toggle('active');
  });
});

document.addEventListener('click', function(e) {
  const parentLink = e.target.closest('.parent-menu');

  if (!parentLink) return;

  const submenu = parentLink.parentElement.querySelector('.menu-drawer__menu--childlist');

  if (submenu) {
    e.preventDefault(); // link ko rok do

    submenu.classList.toggle('active');

    if (submenu.classList.contains('active')) {
      submenu.style.maxHeight = submenu.scrollHeight + 'px';
    } else {
      submenu.style.maxHeight = '0px';
    }
  }
});


// header sticky 

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header'); // <-- actual header tag
  const announcementBar = document.querySelector('.announcement-bar');
  const topMenu = document.querySelector('.header-top-menu');

  function updateOffset() {
    const announcementH = announcementBar?.offsetHeight || 0;
    const topMenuH = topMenu?.offsetHeight || 0;

    document.documentElement.style.setProperty(
      '--header-offset',
      `${announcementH + topMenuH}px`
    );
  }

  updateOffset();
  window.addEventListener('resize', updateOffset);

  window.addEventListener('scroll', () => {
    if (window.scrollY > 80) {
      header.classList.add('header-sticky');
    } else {
      header.classList.remove('header-sticky');
    }
  });
});

// update buy it now button text
document.addEventListener('DOMContentLoaded', () => {
  const updateButtonText = () => {
    const button = document.querySelector(
      '.product-form-buttons button.shopify-payment-button__button'
    );

    if (button) {
      button.textContent = 'Buy Now'; // Apna text yahan likho
    }
  };

  updateButtonText();

  // Shopify dynamic button reload hone par bhi update karega
  const observer = new MutationObserver(updateButtonText);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});